import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import store from "./Store/store";
// import Loader from "./common/Loader";

// const App = React.lazy(() => import("./App"));

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <Suspense fallback={<Loader />}> */}
      <App />
      {/* </Suspense> */}
    </Provider>
  </React.StrictMode>
);
